import React, { useState, useCallback, useImperativeHandle, forwardRef } from 'react';
import { Snackbar } from '@mui/material';

const icons = {
    success: '✓',
    error:   '✕',
    warning: '⚠',
    info:    'ℹ',
};

const colors = {
    success: '#34c759',
    error:   '#ff3b30',
    warning: '#ff9500',
    info:    '#0071e3',
};

const Notifications = forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('success');

    const showSnackbar = useCallback((msg, sev = 'success') => {
        setMessage(msg);
        setSeverity(sev);
        setOpen(true);
    }, []);

    const handleClose = () => setOpen(false);

    useImperativeHandle(ref, () => ({ showSnackbar }));

    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
            <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                backgroundColor: colors[severity],
                color: '#ffffff',
                padding: '9px 14px',
                borderRadius: '12px',
                fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif",
                fontSize: '0.875rem',
                fontWeight: 500,
                letterSpacing: '0.1px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.18)',
                whiteSpace: 'nowrap',
            }}>
                <span style={{ fontSize: '0.85rem', fontWeight: 700, opacity: 0.9 }}>
                    {icons[severity]}
                </span>
                {message}
            </div>
        </Snackbar>
    );
});

export default Notifications;